/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum PriceExplainValueSourceApiModel {
  Defined = 'defined',

  Received = 'received',

  Calculated = 'calculated',

  Reseted = 'reseted',

  PriceByItem = 'price-by-item',

  PriceBySpecialAccount = 'price-by-special-account',

  MasterPriceByDate = 'master-price-by-date',

  PriceGroupTaxByItem = 'price-group-tax-by-item',

  PriceGroupTaxDefault = 'price-group-tax-default',

  PriceGroupTaxDefaultBase = 'price-group-tax-default-base',

  TerminalAdditionalCostByItem = 'terminal-additional-cost-by-item',

  TerminalAdditionalCostDefault = 'terminal-additional-cost-default',

  TerminalAdditionalCostDefaultBase = 'terminal-additional-cost-default-base',

  CorporateAccountPriceOptionByItem = 'corporate-account-price-option-by-item',

  CorporateCategoryAccountPriceOptionByItem = 'corporate-category-account-price-option-by-item',

  RetailCategoryAccountPriceOptionByItem = 'retail-category-account-price-option-by-item',

  RetailCategoryCurrencyPriceOptionByItem = 'retail-category-currency-price-option-by-item'
}
